export const orderSummaryPaperSx = {
  mt: 2,
  border: '1px solid #E0E0E0',
  borderRadius: '8px',
  boxShadow: 'none',
  overflow: 'hidden'
};

export const headerSx = {
  minHeight: 44,
  px: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  bgcolor: '#F5F5F5',
  borderBottom: '1px solid #E0E0E0'
};

export const titleSx = {
  color: '#424242',
  fontSize: 13,
  fontWeight: 500
};

export const editButtonSx = {
  width: 32,
  height: 32,
  color: '#424242',

  '&:hover': {
    bgcolor: '#FFF8E8'
  }
};

export const editIconSx = {
  fontSize: 20
};

export const orderDetailsSx = {
  px: 2,
  py: 1.5
};

export const detailTextSx = {
  color: '#424242',
  fontSize: 13,
  lineHeight: 1.7
};

export const diagnosisHeaderSx = {
  px: 2,
  pt: 1,
  pb: 0.5,
  display: 'flex',
  alignItems: 'center',
  borderTop: '1px solid #F5F5F5'
};

export const diagnosisTitleSx = {
  color: '#4478B5',
  fontSize: 13,
  fontWeight: 600
};

export const diagnosisDetailsSx = {
  px: 2,
  pb: 1
};